import { z } from '../utils/zod.js';
import { dataResponse } from '../utils/response-templates.js';
import { adminOrganizationCompactSchema, adminSigningCompactSchema, adminUserCompactSchema } from './compact.js';
export const ADMIN_SEARCH_LIMIT = 10;
export const adminSearchQuerySchema = z.object({
    q: z.string().trim().min(2).max(255),
});
export const adminSearchResultSchema = z.object({
    users: z.array(adminUserCompactSchema),
    organizations: z.array(adminOrganizationCompactSchema),
    signings: z.array(adminSigningCompactSchema),
});
export const adminSearchResponseSchema = dataResponse(adminSearchResultSchema);
